import { useState, useEffect, Fragment, useCallback } from "react";
import { Menu, Transition } from "@headlessui/react";
import { useAuth0 } from "@auth0/auth0-react";

import { useUserFarms } from "api/user";

export default function EanPicker({ updateFarmName }: any) {
  const { user } = useAuth0();
  const [selectedFarm, setSelectedFarm] = useState(sessionStorage.getItem("farm_name"));

  const updateFarm = useCallback((name: string) => {
    sessionStorage.setItem("farm_name", name);
    setSelectedFarm(name);
    updateFarmName(name);
    // window.location.reload();
  }, []);

  const farms = useUserFarms(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"]);

  useEffect(() => {
    const farmName = sessionStorage.getItem("farm_name");
    if (farms.length && (!farmName || !farms.some((farm: any) => farm.farm_name === farmName))) {
      updateFarm(farms[0].farm_name);
    }
  }, [farms, updateFarm]);



  return (
    <Menu as="div" className={`relative text-gray-500 ${selectedFarm ? "" : "hidden"}`}>
      <div>
        <Menu.Button
          className="max-w-xs rounded flex items-center mx-3 px-4 py-2 text-sm bg-white border border-gray-200 shadow-sm focus:outline-none focus:ring-white"
          id="user-menu-button"
          aria-expanded="false"
          aria-haspopup="true"
        >
          {selectedFarm ?? "Please contact Admin"}
          <span className="sr-only">Open ean menu</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" className="m-3" viewBox="0 0 10 6">
            <path
              id="arrow"
              d="M1.292.16A.568.568,0,0,0,.5.16L.167.487a.54.54,0,0,0,0,.774L3.984,5,.163,8.739a.54.54,0,0,0,0,.774L.5,9.84a.568.568,0,0,0,.79,0L5.837,5.386a.544.544,0,0,0,0-.776Z"
              transform="translate(10) rotate(90)"
              fill="#5273E8"
            />
          </svg>
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className="origin-top-right absolute z-10 right-4 mt-2 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none cursor-pointer"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="user-menu-button"
        >
          {farms.map((farm: any, index: number) => (
            <Menu.Item key={index}>
              <div className="px-4 py-2 text-sm" onClick={() => updateFarm(farm.farm_name)}>{farm.farm_name}</div>
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
